export default __webpack_public_path__ + "fonts/dotted-lineup-header.svg";